<template>
	<div ref="navBarRef">
		<slot :dropdown-open="dropdownOpen"></slot>
	</div>
</template>

<script setup>
import { ref, watch, onMounted, onUpdated, nextTick } from 'vue'
import { store, mutations } from "@js/vue/store.js";
import { onResize } from "@js/throttle.js"
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const navBarRef = ref(null)

const dropdownOpen = ref(false);

watch(() => store.navDropdownOpen, (newVal) => {
	if (newVal) {
		dropdownOpen.value = true;
	} else {
		setTimeout(() => {
			dropdownOpen.value = false;
		}, 300);
	}
});

const getNavBarHeight = () => {
	return navBarRef.value.getBoundingClientRect().height
}

onMounted(() => {
	const height = getNavBarHeight()

	gsap.to(navBarRef.value, {
		scrollTrigger: {
			trigger: "header",
			start: "top top", // Start at the top of the hero section
			end: `bottom top+=${height}`, // End when bottom of hero meets bottom of navbar (adjust 80 to match your navbar height)
			scrub: true, // Smooth scrubbing effect
			markers: false, // Set to true for debugging
		},
		"--nav-opacity": 1, // End with fully opaque background
		"--nav-bottom-border-opacity": 0, // End with fully transparent bottom border
		duration: 1,
	});

	mutations.changeNavBarHeight(height);
})

onUpdated(() => {
	ScrollTrigger.refresh()
})

onResize(() => {
	mutations.changeNavBarHeight(getNavBarHeight())
});

</script>
